import { CoreMenuCollectionPage } from 'dispensary/core-menu/collection';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';

export default Object.assign(CoreMenuCollectionPage, { layout: CoreMenuLayout });
